import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "17",
  height: "17",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", {
        d: "M9.1 1.8v1.8C7.5 4 6.5 5.7 6.9 7.4 7.2 8.5 8 9.3 9.1 9.6v8.7c0 .5.4.9.8.9s.9-.4.9-.8V9.6c1.6-.4 2.6-2.1 2.2-3.8-.3-1.1-1.1-1.9-2.2-2.2V1.8c0-.5-.4-.9-.9-.9-.4 0-.7.4-.8.9q0-.15 0 0m2.3 4.7c0 .8-.6 1.4-1.4 1.4s-1.4-.6-1.4-1.4.6-1.4 1.4-1.4 1.4.6 1.4 1.4M4 18.2v-1.9c1.6-.4 2.6-2.1 2.2-3.8-.3-1.1-1.1-1.9-2.2-2.2V1.8c0-.5-.4-.9-.9-.9s-.9.4-.9.8v8.6c-1.6.4-2.6 2.1-2.2 3.8.3 1.1 1.1 1.9 2.2 2.2v1.9c0 .5.4.9.9.9s.9-.4.9-.9m-2.3-4.8c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4v.1c0 .8-.6 1.4-1.4 1.4-.7-.1-1.3-.8-1.4-1.5M16 1.8v8.6c-1.6.4-2.6 2.1-2.2 3.8.3 1.1 1.1 1.9 2.2 2.2v1.9c0 .5.4.9.9.9s.9-.4.9-.8v-1.9c1.6-.4 2.6-2.1 2.2-3.8-.3-1.1-1.1-1.9-2.2-2.2V1.8c0-.5-.4-.9-.9-.9s-.9.4-.9.9c0-.1 0 0 0 0m2.3 11.6c0 .8-.6 1.4-1.4 1.4s-1.4-.6-1.4-1.4.6-1.4 1.4-1.4c.7 0 1.4.6 1.4 1.4",
        class: "st0-ico-filter"
      })
    ], -1)
  ])))
}
export default { render: render }